module.exports = __webpack_public_path__ + "static/media/icon_google_play_en.d9982832.png";